module.exports = __webpack_public_path__ + "media/images/icon__search--rb-white@2x-aaf9d60b2a136f3aa30c50eff7f9ae71.png";